import { Button, Subheading } from '@criteria-labs/react'
import { type Resource } from '@criteria-labs/docs-kit'
import { PlusCircleIcon } from '@heroicons/react/16/solid'
import { Section } from '../Section'
import { InspectorBody } from '../article'
import { EndpointList } from '../endpoint/EndpointList'
import { useRouter } from '../router'

export function ResourceEndpoints({ resource, resourceIndex }: { resource: Resource; resourceIndex: number }) {
  const { push } = useRouter()
  return (
    <InspectorBody>
      <Section>
        <div className="mb-3 mt-6 flex min-h-10 items-center justify-start gap-x-1">
          <Subheading>Associated endpoints</Subheading>
          <Button plain onClick={() => push(`/resources/${resourceIndex}/new-endpoint`)}>
            <PlusCircleIcon />
          </Button>
        </div>
        <EndpointList endpoints={resource.endpoints} showResourceColumn={false} />
      </Section>
    </InspectorBody>
  )
}
